import React, { useState, useEffect } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import Select from 'react-select';
import countryList from 'react-select-country-list';
import * as Yup from 'yup';
import '../../stylesheets/CustomAlert.css';
import FormSelect from './FormSelect';  // Import FormSelect
import { UserManagementAPI } from '../../axios';

// Define validation schema using Yup
const AddUserSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  email: Yup.string().email('Invalid email address').required('Email is required'),
  password: Yup.string().required('Password is required'),
  roles: Yup.string().required('Role is required'),
  countries: Yup.array().min(1, 'At least one country is required').required('Country is required'),
});

const AddUser = ({ onCancel, onSubmit }) => {
  const [roleNames, setRoleNames] = useState([]);
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);  // Add loading state
  const [initialValues, setInitialValues] = useState({
    name: '',
    email: '',
    password: '',
    roles: '',
    countries: [], // Initialize as an empty array
  });

  useEffect(() => {
    UserManagementAPI.fetch_roles()
      .then((res) => {
        if (res.code === 200) {
          const roleNames = res.data.roles.map(role => role.name);
          setRoleNames(roleNames);
          setInitialValues((prevValues) => ({
            ...prevValues,
            roles: '', // Ensure roles field is updated accordingly
          }));
        }
      })
      .catch((err) => {
        console.log(err);
      });

    setCountries(countryList().getData());
  }, []);

  const handleSubmit = (values) => {
    setLoading(true);  // Set loading to true when form is submitted
    UserManagementAPI.add_admin_user(JSON.stringify(values))
      .then((res) => {
        if (res.code === 200) {
          onSubmit(res.data.savedAdminUser);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);  // Set loading to false once the API call is done
      });
  };

  return (
    <div className="custom-alert-overlay">
      <div className="custom-alert-edit">
        <button className="custom-alert-close" onClick={onCancel} disabled={loading}>×</button>  {/* Disable close button while loading */}
        <div className='heading'>
          <span>Add New User</span>
        </div>
        <Formik
          initialValues={initialValues}
          validationSchema={AddUserSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ setFieldValue, values }) => (
            <Form className="inputs-edit">
              <span className='label'>Name</span>
              <div className="input-edit">
                <Field type="text" name="name" placeholder="Enter name" />
              </div>
              <ErrorMessage name="name" component="div" className="error" />
              <span className='label'>Email</span>
              <div className="input-edit">
                <Field type="email" name="email" placeholder="Enter email" />
              </div>
              <ErrorMessage name="email" component="div" className="error" />
              <span className='label'>Password</span>
              <div className="input-edit">
                <Field type="password" name="password" placeholder="Enter password" />
              </div>
              <ErrorMessage name="password" component="div" className="error" />
              <span className='label'>Roles</span>
              <FormSelect
                name="roles"
                options={roleNames}
              />
              <ErrorMessage name="roles" component="div" className="error" />
              <span className='label'>Countries</span>
              <Select
                name="countries"
                options={countries}
                isMulti
                value={countries.filter(option => values.countries.includes(option.label))}
                onChange={(selectedOptions) => {
                  const selectedCountries = selectedOptions ? selectedOptions.map(option => option.label) : [];
                  setFieldValue("countries", selectedCountries);
                }}
                className="react-select-container"
                classNamePrefix="react-select"
              />
              <ErrorMessage name="countries" component="div" className="error" />
              <button
                type="submit"
                className="edit-save-button"
                disabled={loading}  // Disable button while loading
              >
                {loading ? 'Adding...' : 'Add New User'}  {/* Change button text while loading */}
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default AddUser;
